import { render, staticRenderFns } from "./challenging_situations.vue?vue&type=template&id=5792400a&scoped=true&"
import script from "./challenging_situations.vue?vue&type=script&lang=js&"
export * from "./challenging_situations.vue?vue&type=script&lang=js&"
import style0 from "./challenging_situations.vue?vue&type=style&index=0&id=5792400a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5792400a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
